import styled from "styled-components";
import wireLines from "../../../assets/icons/wire-lines.svg";

export const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-brand);
  border-radius: 10px;
  width: 100%;
  color: white;
  overflow: hidden;
  background-image: url(${wireLines});
  background-size: contain;
  background-position: center;
  padding-top: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;
    max-height: 209px;
    padding-top: 0;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  text-align: center;
  width: 100%;

  @media (min-width: 768px) {
    padding: 2rem;
    text-align: left;
    max-width: 50%;
    margin-bottom: 0;
  }
`;

export const Title = styled.h1`
  font-family: "Suisse International", sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 8px;
  line-height: 34px;
  color: #ffff;

`;

export const Subtitle = styled.p`
  font-size: 16px;
  font-family: 'Inter';
  margin-bottom: 20px;
  line-height: 24px;
  max-width: 500px;
  
  @media (max-width: 768px) {
    margin: 0 auto 20px;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  @media (min-width: 768px) {
    width: 50%;
    padding: 2rem;
  }
`;

export const StyledButton = styled.button`
  height: 56px;
  background-color: black;
  color: white;
  border: none;
  border-radius: 8px;
  width: 100%;
  font-size: 20px;
  line-height: 32px;
  font-family: 'Inter';
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 400;

  &:hover {
    background-color: rgba(0, 0, 0, 0.9);
  }

  @media (min-width: 768px) {
    width: 160px;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  max-width: 600px;
`;
